import { Sort } from "../../components/@types";
import { Timerange } from "../search/@types";
import { IListYaraRulesetsParams } from "./hooks/useListYaraRulesets";

export const YARA_DATA = "yaraData";
export const YARA_SAMPLES = "getYaraSamples";
export const YARA_MATCHES = "getYaraMatches";
export const YARA_REVISION_HISTORY_FOR_RULESET =
  "getYaraRevisionHistoryForRuleset";

export const YARA_STATUS_KEY = "yaraStatus";

export const YARA_REPOSITORIES = "yaraRepositories";
export const YARA_REVISION_DETAILS = "yara_revision_details";

export const yaraQueryKey = {
  tags: ["allTags"],
  fetchRule: (id: string) => ["yaraFetchRule", id],
  rulesetDetails: (id: string) => ["yaraRulesetDetails", id],
  testRunResult: (id: string | undefined) => ["yaratestrunResult", id],
  postTestRun: ["postTestRun"],
  postTestReanalyze: ["postTestReanalyze"],
  getLatestTestrunByRuleset: (qp?: { revision_id: string }) => [
    "getLatestTestrunByRuleset",
    qp
  ],
  getYaraTestRunSamples: ["getYaraTestRunSamples"],
  getYaraRulesets: (
    rulesetNameFilter?: string,
    rulesetOwnerFilter?: string,
    rulesetStatusFilter?: string,
    rulesetSourceFilter?: string,
    rulesetSort?: Sort,
    includeNewMatches?: boolean
  ) => [
    YARA_DATA,
    rulesetNameFilter,
    rulesetOwnerFilter,
    rulesetStatusFilter,
    rulesetSourceFilter,
    rulesetSort?.field,
    rulesetSort?.direction,
    includeNewMatches
  ],
  getYaraRulesetList: (params?: IListYaraRulesetsParams) => [
    "listYaraRulesets",
    params
  ],
  getYaraRefData: () => ["yaraRefData"],
  getLocalYaraStatus: () => [YARA_STATUS_KEY, "local"],
  getCloudYaraStatus: () => ["getCloudYaraStatus"],
  getRemoteYaraStatus: () => [YARA_STATUS_KEY, "remote"],
  getYaraRevisionAggregated: (
    revisionId?: number,
    rulesetId?: number,
    ruleId?: string | null,
    classificationName?: string | null,
    fileFormatName?: string | null,
    threatTypeName?: string | null,
    timerange?: Timerange,
    matchesType?: string | null
  ) => [
    YARA_SAMPLES,
    revisionId,
    rulesetId,
    ruleId,
    classificationName,
    fileFormatName,
    threatTypeName,
    timerange,
    matchesType
  ],
  getYaraMatches: (
    revisionId?: number,
    page?: number,
    pageSize?: number,
    ruleId?: string | null,
    classificationName?: string | null,
    fileFormatName?: string | null,
    threatTypeName?: string | null,
    timerange?: Timerange,
    matchesType?: string | null,
    sortField?: string,
    sortDirection?: string
  ) => [
    YARA_MATCHES,
    revisionId,
    page,
    pageSize,
    ruleId,
    classificationName,
    fileFormatName,
    threatTypeName,
    timerange,
    matchesType,
    sortField,
    sortDirection
  ],
  getYaraRevisionHistoryForRuleset: (rulesetId?: number) => [
    YARA_REVISION_HISTORY_FOR_RULESET,
    rulesetId
  ],
  getYaraRulesForRevision: (revisionId?: number) => [
    "getYaraRulesForRevision",
    revisionId
  ],
  getYaraRevisionDetails: (revisionId?: number | string) => [
    YARA_REVISION_DETAILS,
    revisionId
  ],
  getYaraSyncStatus: () => ["getYaraSyncStatus"]
};
